import { Model } from "@ofqual/portal-core/core/types";
import { UserType } from "../redux/types";
import { Attachment } from "./Attachment";

export type ContactTheRegulator = {
  id: string;
  title: string;
  messageBody: string;
  sendToOfqual: boolean;
  sendToCcea: boolean;
  files: File[];
  ctrCategorys: string[];
  ctrConditions: string[];
  ctrAttachments: Attachment[];
  resourceTags: number[];
  orgName: string;
  closedByDisplayName: string;
  closedByUpn: string;
  closedDate: string;
  createdByUpn: string;
  createdByDisplayName: string;
  createdDate: string;
  lastResponseByUpn: string;
  lastResponseByDisplayName: string;
  lastResponseDate: string;
  lastResponseByUserType: UserType;
  ofqualAssignedToDisplayName: string;
  ofqualAssignedToUpn: string;
  cceaAssignedToUpn: string;
  cceaAssignedToDisplayName: string;
  status: CtrStatus;
  orgId: number;
};

export enum CtrStatus {
  New = 0,
  Active = 1,
  Closed = 2,
}

export const fromApiModel = (model: Model): ContactTheRegulator => {
  return {
    ...model
  } as ContactTheRegulator;
};

export const toApiModel = (item: ContactTheRegulator): Model => {
  return {
    ...item,
  } as Model;
};

export const defaultValues = {
  title: "",
  messageBody: "",
  sendToOfqual: false,
  sendToCcea: false,
  files: [],
  ctrCategorys: [],
  ctrConditions: [],
  resourceTags: [],
}